/* eslint-disable no-undef */
import { Box } from "@mui/material";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import {
  renderSiteAddress,
  renderSiteDNSP,
  renderSiteStatus,
  renderSiteStatusIcons,
  renderSiteUnits,
} from "components/DataTable/renderComponents";
import { useCallback, useEffect, useState } from "react";

const containerStyle = {
  minWidth: "100%",
  minHeight: "400px",
  height: "100%",
};

const SiteInfoWindow = ({ marker }) => {
  return (
    <Box
      width="500px"
      sx={{
        "& .status-icon-group": {
          justifyContent: "flex-start",
        },
        gap: 0.5,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box>{renderSiteStatus(marker)}</Box>
      <Box>{renderSiteStatusIcons(marker)}</Box>
      <Box onClick={(e) => e.stopPropagation()}>{renderSiteUnits(marker)}</Box>
      <Box>{renderSiteDNSP(marker)}</Box>
      <Box>{renderSiteAddress(marker)}</Box>
    </Box>
  );
};

const SiteMap = ({ list = [] }) => {
  const initialCenter = {
    lat: -33.765515,
    lng: 151.272005,
  };

  const [zoom, setZoom] = useState(10);
  const [center, setCenter] = useState(initialCenter);
  const [locatedCenter, setLocatedCenter] = useState(false);
  const [activeMarker, setActiveMarker] = useState(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  });

  // eslint-disable-next-line no-unused-vars
  const [map, setMap] = useState(null);

  useEffect(() => {
    if (list.length > 0 && !locatedCenter) {
      const site = list[0];
      setLocatedCenter(true);
      setCenter({
        lat: site?.details?.latitude,
        lng: site?.details?.longitude,
      });
      setZoom(10);
    }
  }, [list]);

  const onLoad = useCallback(function callback(map) {
    map.setZoom(zoom);

    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback() {
    setMap(null);
  }, []);

  const redMarkerIcon = isLoaded
    ? {
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
        scaledSize: new window.google.maps.Size(44, 40),
      }
    : null;

  return (
    <Box height="100%">
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          options={{ zoomControlOptions: { position: 5 } }}
          center={center}
          zoom={zoom}
          onLoad={onLoad}
          onUnmount={onUnmount}
        >
          <Box>
            {list.map((marker, i) => (
              <Marker
                key={i}
                {...marker}
                icon={redMarkerIcon}
                title={marker?.details?.nmi}
                name={marker?.details?.nmi}
                position={{
                  lat: Number(marker?.details?.latitude),
                  lng: Number(marker?.details?.longitude),
                }}
                onClick={() => setActiveMarker(marker)}
              >
                {activeMarker?.id === marker.id ? (
                  <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                    <SiteInfoWindow marker={marker} />
                  </InfoWindow>
                ) : null}
              </Marker>
            ))}
          </Box>
        </GoogleMap>
      )}
    </Box>
  );
};

export default SiteMap;
